module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4da38973d5ffd15c54e80894d430288c.svg";